import { type UserInfoType } from "../profile/user-info";
import { type RoomInfoType } from "./room";

export interface Token {
  id: string;
  contract_address: string;
  is_coin: boolean;
  decimals_places: number;
  network_id: string;
  name: string;
  symbol: string;
  image_url: string;
  network: Network;
}

interface SubscriptionPlan {
  id: string;
  price: string;
  duration: number;
  is_enabled: boolean;
  target_entity_id: string;
  target_entity_type: string;
  token: Token;
  network: Network;
}

enum TxLedgerEntryType {
  SUBSCRIPTION_EARNED = "subscription_earned",
  SERVICE_FEE_PAID = "service_fee_paid",
  REFERRAL_COMMISSION_EARNED = "referral_commission_earned",
  REFERRAL_COMMISSION_PAID = "referral_commission_paid",
  WITHDRAWAL = "withdrawal",
}

export const DescriptionTranslationKey = {
  [TxLedgerEntryType.SUBSCRIPTION_EARNED]: "new_audience_subscribed",
  [TxLedgerEntryType.SERVICE_FEE_PAID]: "service_fee_paid",
  [TxLedgerEntryType.REFERRAL_COMMISSION_EARNED]:
    "new_audience_subscription_referral",
  [TxLedgerEntryType.REFERRAL_COMMISSION_PAID]:
    "referral_commission_for_new_audience_subscription",
  [TxLedgerEntryType.WITHDRAWAL]: "claimed",
};

export interface Network {
  id: string;
  name: string;
  chain_id: number;
  http_url: string;
  wss_url: string | null;
  tx_link: string;
  address_link: string | null;
  community_factory: string;
  social_contract: string;
  following_contract: string;
  followed_contract: string;
  pay_to_open_contract: string;
  audience_contract: string;
  image_url: string;
  symbol: string;
  created_at: string;
  updated_at: string;
}

export interface Avatar {
  id: string;
  url: string;
  key: string;
  attachment_type: string;
  metadata: any | null;
  dimension: any | null;
  multipart_data: any | null;
  e_tag: any | null;
  created_at: string;
  updated_at: string;
  is_completed: any | null;
  thumbnail_url: string | null;
}

export interface SubsPlanType {
  id: string;
  token_id: string;
  target_entity_id: string;
  target_entity_type: string;
  plan_type: string;
  duration: number;
  price: string;
  tx_hash: string;
  block_no: number;
  is_enabled: boolean;
  created_at: string;
  updated_at: string;
  room: RoomInfoType;
}

export interface UserSubscription {
  id: string;
  user_id: string;
  subscription_plan_id: string;
  end_date: number;
  tx_hash: string;
  created_at: string;
  updated_at: string;
  user?: UserInfoType;
  subscription_plan: SubsPlanType;
}

interface RevenueHistoryType {
  id: string;
  amount: string;
  chain_id: number;
  token_id: string;
  user_id: string;
  from_user_id: string | null;
  to_user_id: string | null;
  tx_hash: string;
  log_index: number;
  ref_entity_id: string;
  ref_entity_type: string;
  ledger_entry_type: TxLedgerEntryType;
  created_at: string;
  token: Token;
  from_user?: UserInfoType | null;
  to_user?: UserInfoType | null;
  user_subscription?: UserSubscription | null;
}

interface SubscribedType {
  id: string;
  created_at: string;
  end_date: number;
  updated_at: string;
  tx_hash: string;
  user_subscription: UserSubscription;
  subscription_plan_id: string;
  subscription_plan: SubsPlanType & { token: Token };
}

export {
  type SubscriptionPlan,
  TxLedgerEntryType,
  type RevenueHistoryType,
  type SubscribedType,
};
